import { render, staticRenderFns } from "./contentCourseLearnerViewActivity.vue?vue&type=template&id=020b0b7c&"
import script from "./contentCourseLearnerViewActivity.vue?vue&type=script&lang=js&"
export * from "./contentCourseLearnerViewActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports